import { atom } from '@reatom/framework'

import { selectedNetworkAtom } from '@root/entities/network'
import { tradingWalletIdAtom } from '@root/features/trade/trading'
import { reatomUserPositions } from '@root/features/user/user-positions'

export const tradingPositionsModelAtom = atom((ctx) => {
  const walletId = ctx.spy(tradingWalletIdAtom)
  const network = ctx.spy(selectedNetworkAtom)

  // eslint-disable-next-line @reatom/unit-naming-rule
  const positionsStateAtom = reatomUserPositions({
    network: network,
    walletId: walletId,
  })

  return positionsStateAtom
}, 'tradingPositionsModelAtom')
